import { render, staticRenderFns } from "./GroupPicker.vue?vue&type=template&id=266445b8&scoped=true"
import script from "./GroupPicker.vue?vue&type=script&lang=js"
export * from "./GroupPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266445b8",
  null
  
)

export default component.exports